export type LoadersProps<T> = {
  props?: T;
  isLoading?: boolean;
};

export enum NvsLoadersTypes {
  Pixelation = "Pixelation",
}

export type NvsLoadersKey = keyof typeof NvsLoadersTypes;
export type NvsLoadersValue = typeof NvsLoadersTypes[NvsLoadersKey];

export type NvsLoadersProps = {
  loader: NvsLoadersValue;
};

export type PixelationLoaderProps = {
  isLoading?: boolean;
};
